import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Divider } from "@gemini/ui";
import { Box, useHoverable, usePressable } from "@gemini/core";
import { EmojiGrinning, EmojiNeutral, EmojiSad, EmojiSmile, EmojiFrowning, } from "./components/EmojisRating";
import { useTrackingDatas } from "@/hooks/tracking";
import { useClassifiedId } from "@/contexts/classified";
import { useI18n } from "@/shared/hooks";
import { useBrandContext } from "@/shared/contexts";
export const FeedbackSurvey = () => {
    var _a, _b;
    const { t } = useI18n();
    const brandConfiguration = useBrandContext();
    const { urls: { qualtricsSurvey }, } = brandConfiguration;
    const trackingEstateType = (_a = useTrackingDatas()) === null || _a === void 0 ? void 0 : _a.av_estate_type_global;
    const trackingDistributionType = (_b = useTrackingDatas()) === null || _b === void 0 ? void 0 : _b.av_distribution_type_global;
    const id = useClassifiedId();
    const satisfactionOptions = [
        { value: 1, icon: _jsx(EmojiFrowning, {}) },
        { value: 2, icon: _jsx(EmojiSad, {}) },
        { value: 3, icon: _jsx(EmojiNeutral, {}) },
        { value: 4, icon: _jsx(EmojiSmile, {}) },
        { value: 5, icon: _jsx(EmojiGrinning, {}) },
    ];
    const handleRatingClick = (value) => {
        const url = `${qualtricsSurvey}&eval=${value}&av_distribution_type_global=${trackingDistributionType}&av_estate_type_global=${trackingEstateType}&av_items.0.id=${id}`;
        window.open(url, "_blank");
    };
    return (_jsxs(Box, { as: "section", gridColumn: {
            "breakpoint.base": "col-start / span 4",
            "breakpoint.md": "col-start / span 8",
            "breakpoint.lg": "col-start / span 12",
            "breakpoint.sm": "col-start / span 8",
            "breakpoint.xl": "col-start 1 / span 12",
            "breakpoint.xxl": "col-start 2 / span 10",
        }, paddingHorizontal: {
            "breakpoint.base": "spacing.16",
            "breakpoint.sm": "spacing.32",
            "breakpoint.lg": "spacing.none",
        }, unsafe_className: "HideOnPrint", children: [_jsx(Divider, { marginBottom: "spacing.32" }), _jsx(Box, { display: "flex", justifyContent: "center", paddingTop: "spacing.32", children: _jsx(Box, { as: "span", typography: "typography.headline.20.bold", textAlign: "center", marginBottom: "spacing.40", children: t("feedback_survey.headline") }) }), _jsx(Box, { display: "flex", justifyContent: {
                    "breakpoint.base": "space-between",
                    "breakpoint.sm": "center",
                }, paddingBottom: "spacing.32", children: satisfactionOptions.map(({ value, icon }) => (_jsx(RatingOption, { onPress: () => handleRatingClick(value), children: icon }, value))) }), _jsx(Divider, { marginTop: "spacing.32" })] }));
};
const RatingOption = ({ onPress, children }) => {
    const { boxProps: hoverProps, isHovered } = useHoverable();
    const { boxProps: pressProps, isPressed } = usePressable({ onPress });
    return (_jsx(Box, { as: "button", backgroundColor: isHovered
            ? "color.surface.default.hover"
            : "color.content.constant.white", borderRadius: "radius.8", borderWidth: isPressed ? "borderWidth.2" : "borderWidth.1", borderColor: isPressed
            ? "color.border.interactive.pressed"
            : "color.border.light.default", borderStyle: "solid", padding: {
            "breakpoint.base": "spacing.12",
            "breakpoint.md": "spacing.16",
        }, width: {
            "breakpoint.base": "sizing.56",
            "breakpoint.md": "sizing.72",
        }, height: {
            "breakpoint.base": "sizing.56",
            "breakpoint.md": "sizing.72",
        }, cursor: "pointer", marginRight: {
            "breakpoint.base": "spacing.none",
            "breakpoint.sm": "spacing.24",
        }, onClick: onPress, ...pressProps, ...hoverProps, children: children }));
};
